import { apiClient } from './client';

/**
 * Get Q&A threads for a course lesson
 * @param {string} courseId
 * @param {string} lessonId
 * @param {{ page?, limit?, sortBy?, sortOrder?, status?, search? }} params
 */
export async function getThreads(courseId, lessonId, params = {}) {
  const { data } = await apiClient.get(`/courses/${courseId}/lessons/${lessonId}/threads`, { params });
  return data;
}

/**
 * Every Q&A thread of a course in one request (staff: the course's teachers and admins). Each
 * thread carries its lessonId and lessonTitle. Open threads come first, newest first within each
 * status.
 * @param {string} courseId
 * @param {{ status?: string }} params - 'OPEN', 'ANSWERED', 'CLOSED' or a comma-separated list
 */
export async function getCourseThreads(courseId, params = {}) {
  const { data } = await apiClient.get(`/courses/${courseId}/threads`, { params });
  return data;
}

/**
 * Create a new Q&A thread
 * @param {string} courseId
 * @param {string} lessonId
 * @param {object} body - { title, content }
 */
export async function createThread(courseId, lessonId, body) {
  const { data } = await apiClient.post(`/courses/${courseId}/lessons/${lessonId}/threads`, body);
  return data;
}

/**
 * Get single thread with replies
 * @param {string} courseId
 * @param {string} lessonId
 * @param {string} threadId
 */
export async function getThread(courseId, lessonId, threadId) {
  const { data } = await apiClient.get(`/courses/${courseId}/lessons/${lessonId}/threads/${threadId}`);
  return data;
}

/**
 * Reply to a thread
 * @param {string} courseId
 * @param {string} lessonId
 * @param {string} threadId
 * @param {object} body - { content }
 */
export async function replyToThread(courseId, lessonId, threadId, body) {
  const { data } = await apiClient.post(`/courses/${courseId}/lessons/${lessonId}/threads/${threadId}/replies`, body);
  return data;
}
